import React, { useState, useEffect } from "react";
import RewardsData from "./RewardsData";
import EarnedRewards from "./EarnedRewards";
import { rewardStyle as styles } from "../redeemRewards.tailwind";
import { useSelector } from "react-redux";
import no_rewards_found from '../../../../../assets/images/no_rewards_found.png';
import { getRemainingPoints, NO_LIMIT_REWARD_TEXT } from "./rewards.data";
import SignUpUpdatesModal from "../../../../shared/Modals/RedeemRewardsModals/SignUpUpdatesModal/SignUpUpdatesModal";
import RedeemRewardSkeleton from "../../../shared/Skeletons/RedeemRewardSkeleton/RedeemRewardSkeleton";

const Rewards = () => {
  const { rewards: rewardsFromApi, rewardsLoading } = useSelector((state) => state.reward); // Fetch rewards and loading state from Redux
  const { user } = useSelector((state) => state.user);
  const userDetails = user?.userDetails;
  // current season's id
  const { currentSeason } = useSelector((state) => state.seasons);
  const seasonId = currentSeason?._id;

  const [rewards, setRewards] = useState([]);
  const [claimingRewardId, setClaimingRewardId] = useState(null);
  const [showEarnedRewards, setShowEarnedRewards] = useState(false); // Toggle for earned rewards
  // const [Date, setDate] = useState("");
  const [open, setOpen] = useState(false); // Sign-Up Updates Modal

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const toggleEarnedRewards = () => {
    setShowEarnedRewards(!showEarnedRewards);
  };

  useEffect(() => {
    const availableRewards = []
    rewardsFromApi.forEach((reward) => {
      const _remaining = getRemainingPoints(reward);
      // const _reaminingForUser = getRemainingPointsForUser(reward);

      if(_remaining === NO_LIMIT_REWARD_TEXT || (_remaining > 0)) {
        availableRewards.push(reward)
      }
    })

    setRewards(availableRewards)
  }, [rewardsFromApi])

  // const callApi = () => {
  //   if(apiDataRef.current) return;
  //   apiDataRef.current = true;
  //   const data = { };
  //   handleFilter();
  // }

  // const handleFilter = () =>{

  //   apiDataRef.current = false; // Reset API call lock to allow re-fetch
  //   callApi();
  // }

  return (
    <div className={styles.outerContainer} style={{
      borderRadius: "0px 10px 10px 10px"
    }}>     
      {!userDetails?.optInForUpdateEmail && (
        <span className={styles.signUp}>
          <span className={styles.link} onClick={handleOpen}>
            Sign Up
          </span>{" "}
          here to get notified when new rewards become available
        </span>
      )}
      <div className={styles.header}>
        {/* {showEarnedRewards ? (
          <Button variant="primary" className={styles.backButtonContainer} onClick={toggleEarnedRewards}>
            <ChevronLeftIcon sx={{ fontSize: '20px' }} />
            <span>Back</span>
          </Button>
        ) : ( 
          <> */}
            {/* Heading */}
            <div className={styles.headingContainer}>
                {/* <span className={styles.heading}>
                  {showEarnedRewards ? `Redeemed Rewards` : `Rewards`}
                </span> */}
                
                <button className={`${styles.tabsbutton} ${showEarnedRewards ? styles.activeButton2 : 'text-themeColor'}`} onClick={() => setShowEarnedRewards(false)}>Redeem Rewards</button>
                <button className={`${styles.tabsbutton} ${!showEarnedRewards ? styles.activeButton2 : 'text-themeColor'}`} onClick={() => setShowEarnedRewards(true)}>My Rewards</button>

                {/* Earned Rewards link */}
                {/* {!showEarnedRewards ? (
                  <div className={styles.earnedRewards}>
                    <EmojiEventsIcon sx={{ fontSize: '17px', color: '#FFD700' }} />
                    <span className={styles.earnedRewardsText} onClick={toggleEarnedRewards}>
                      Redeemed Rewards
                    </span>
                  </div>
                ) : (
                  // When the "Earned Rewards" view is active, show the "Earn More Rewards" link
                  <div className={styles.earnedRewards}>
                    <EmojiEventsIcon sx={{ fontSize: '17px', color: '#FFD700' }} />
                    <span className={styles.earnedRewardsText} onClick={toggleEarnedRewards}>
                      Redeem More Rewards
                    </span>
                    {/* <div className="flex gap-1 items-center">
                      <label className="block text-sm font-medium">
                      Date
                      </label>
                      <input
                        type="date"
                        value={Date}
                        onChange={(e) => setDate(e.target.value)}
                        className="p-[2px] bg-white text-black block w-full  border-gray-300 rounded-md shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-[10px] sm:text-[12px]"
                      />
                      <button onClick={handleFilter}>Apply</button>
                  </div>
                  </div>
                )} */}
            </div>
              
          {/* </>
        )} */}
      </div>

      {/* Earned Rewards */}
      {showEarnedRewards ? (
        <EarnedRewards seasonId={seasonId} toggleRewardsView={toggleEarnedRewards} />
      ) : (
        <div className={styles.rewardDataContainer}>
          {rewardsLoading ? (
            <RedeemRewardSkeleton />    
            
          ) : !rewardsLoading && rewards && rewards?.length === 0 ? (
            // if rewards are not available
            <div className={styles.noRewardsMessage}>
              <img src={no_rewards_found} alt="No rewards" className={styles.noRewardsImage} />
              <span className={styles.noRewardsText}>No rewards available at the moment.</span>
            </div>
          ) : (
            rewards?.map((reward, key) => (
              <RewardsData
                key={key}
                reward={reward}
                seasonId={currentSeason?._id}
                setClaimingRewardId={setClaimingRewardId}
                isClaimingCurrent={claimingRewardId === key}
                index={key}
                toggleRewardsView={toggleEarnedRewards}
              />
            ))
          )}
        </div>
      )}

      <SignUpUpdatesModal isOpen={open} onClose={handleClose} />
    </div>
  );
};

export default Rewards;
